export const getRandomHexColor = () => {
    const rgb = crypto.getRandomValues(new Uint8Array(3));
    return `#${Array.from(rgb, (value) => value.toString(16).padStart(2, '0')).join('')}`;
};
